module.exports = __webpack_public_path__ + "img/how-to-give-bg.d47b88db.jpg";